export default __webpack_public_path__ + "static/media/eshel1.9908d723.jpg";